// PWA Service Worker Registration
export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register("/serviceWorker.js");
      console.log("SW registered: ", registration);
      return registration;
    } catch (registrationError) {
      console.log("SW registration failed: ", registrationError);
    }
  }
};

// Check if app is installed
export const isAppInstalled = () => {
  return (
    window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true
  );
};

// Check if app can be installed
export const canInstallApp = () => {
  return "BeforeInstallPromptEvent" in window;
};

// Handle app installation
export const handleAppInstall = beforeInstallPromptEvent => {
  beforeInstallPromptEvent.preventDefault();
  beforeInstallPromptEvent.prompt();

  return beforeInstallPromptEvent.userChoice.then(choiceResult => {
    if (choiceResult.outcome === "accepted") {
      console.log("User accepted the install prompt");
      return true;
    } else {
      console.log("User dismissed the install prompt");
      return false;
    }
  });
};

// Request notification permission
export const requestNotificationPermission = async () => {
  if ("Notification" in window) {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  }
  return false;
};

// Show notification
export const showNotification = (title, options = {}) => {
  if ("Notification" in window && Notification.permission === "granted") {
    const defaultOptions = {
      icon: "/BNT_Logo.png",
      badge: "/BNT_Logo.png",
      vibrate: [100, 50, 100],
      ...options
    };

    return new Notification(title, defaultOptions);
  }
};

// Check online/offline status
export const isOnline = () => {
  return navigator.onLine;
};

// Add online/offline event listeners
export const addConnectivityListeners = (onOnline, onOffline) => {
  window.addEventListener("online", onOnline);
  window.addEventListener("offline", onOffline);
};

// Remove online/offline event listeners
export const removeConnectivityListeners = (onOnline, onOffline) => {
  window.removeEventListener("online", onOnline);
  window.removeEventListener("offline", onOffline);
};

// Get app version from manifest
export const getAppVersion = async () => {
  try {
    const response = await fetch("/manifest.json");
    const manifest = await response.json();
    return manifest.version || "2.2.0";
  } catch (error) {
    console.error("Error fetching manifest:", error);
    return "2.2.0";
  }
};

// Check for app updates
export const checkForUpdates = registration => {
  if (registration && registration.updatefound) {
    const newWorker = registration.installing;

    newWorker.addEventListener("statechange", () => {
      if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
        // New content is available
        showNotification("App Update Available", {
          body: "A new version of the app is available. Refresh to update.",
          actions: [
            {
              action: "refresh",
              title: "Refresh"
            }
          ]
        });
      }
    });
  }
};

// Background sync registration
export const registerBackgroundSync = async (tag = "background-sync") => {
  if ("serviceWorker" in navigator && "sync" in window.ServiceWorkerRegistration.prototype) {
    const registration = await navigator.serviceWorker.ready;
    return registration.sync.register(tag);
  }
  return false;
};

// Cache management
export const clearOldCaches = async () => {
  if ("caches" in window) {
    const cacheNames = await caches.keys();
    const currentCache = "hrm-portal-v1";

    return Promise.all(
      cacheNames.map(cacheName => {
        if (cacheName !== currentCache) {
          return caches.delete(cacheName);
        }
      })
    );
  }
};
